import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import paymentService from "../../services/paymentService";

export const fetchPayments = createAsyncThunk(
  "payments/fetchPayments",
  async () => {
    return await paymentService.getAllPayments();
  },
);

export const fetchPaymentsByDoctor = createAsyncThunk(
  "payments/fetchPaymentsByDoctor",
  async (doctorId) => {
    return await paymentService.getPaymentsByDoctor(doctorId);
  },
);

export const addPayment = createAsyncThunk(
  "payments/addPayment",
  async (paymentData) => {
    return await paymentService.createPayment(paymentData);
  },
);

export const removePayment = createAsyncThunk(
  "payments/removePayment",
  async (id) => {
    await paymentService.deletePayment(id);
    return id;
  },
);

const paymentSlice = createSlice({
  name: "payments",
  initialState: {
    payments: [],
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    // Fetch all payments
    builder
      .addCase(fetchPayments.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPayments.fulfilled, (state, action) => {
        state.loading = false;
        state.payments = action.payload;
      })
      .addCase(fetchPayments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });

    // Fetch payments by doctor
    builder
      .addCase(fetchPaymentsByDoctor.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPaymentsByDoctor.fulfilled, (state, action) => {
        state.loading = false;
        state.payments = action.payload;
      })
      .addCase(fetchPaymentsByDoctor.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });

    // Add payment
    builder
      .addCase(addPayment.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addPayment.fulfilled, (state, action) => {
        state.loading = false;
        state.payments.push(action.payload);
      })
      .addCase(addPayment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });

    // Delete payment
    builder
      .addCase(removePayment.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(removePayment.fulfilled, (state, action) => {
        state.loading = false;
        state.payments = state.payments.filter(
          (p) => p.payment_id !== action.payload,
        );
      })
      .addCase(removePayment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default paymentSlice.reducer;
